var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _vm.selectedMenu == "rationales"
        ? _c("div", { staticClass: "row mtl-25-10" }, [
            _c("div", { staticClass: "col-md-10 col-sm-10 col-xs-12" }, [
              _c(
                "a",
                {
                  staticClass: "sub-heading",
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function ($event) {
                      return _vm.routeProdClass()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-angle-left" }),
                  _vm._v("Product Classification "),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "row tracker-container" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 box-body" },
          [
            _c("product-classification-tabs", {
              attrs: {
                resetSearch: _vm.resetSearch,
                rationaleCount: _vm.total,
                activeItem: _vm.selectedMenu,
              },
              on: { selectedMenu: _vm.selectedMenuItem },
            }),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.selectedMenu == "rationales"
                  ? [
                      _c("product-classification-rationale-grid", {
                        ref: "accountsList",
                        on: { pagechanged: _vm.pagechanged },
                        model: {
                          value: _vm.selectedRationales,
                          callback: function ($$v) {
                            _vm.selectedRationales = $$v
                          },
                          expression: "selectedRationales",
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }